const MODULE = document.querySelectorAll('[data-module="texto_imagem_video"]');

class TextoImagemVideo {
    static apiReadyPromise = null;
    static players = new Map();

    constructor() {
        this.components = MODULE;
        this.init();
    }

    async init() {
        if (!this.components.length) return;

        await this.loadYouTubeAPI();

        this.components.forEach((component) => {
            this.initComponent(component);
        });
    }

    loadYouTubeAPI() {
        if (window.YT && window.YT.Player) {
            return Promise.resolve();
        }

        if (TextoImagemVideo.apiReadyPromise) {
            return TextoImagemVideo.apiReadyPromise;
        }

        TextoImagemVideo.apiReadyPromise = new Promise((resolve) => {
            const scriptId = 'yt-iframe-api';

            if (!document.getElementById(scriptId)) {
                const tag = document.createElement('script');
                tag.id = scriptId;
                tag.src = 'https://www.youtube.com/iframe_api';
                document.head.appendChild(tag);
            }

            const previousCallback = window.onYouTubeIframeAPIReady;

            window.onYouTubeIframeAPIReady = () => {
                if (typeof previousCallback === 'function') {
                    previousCallback();
                }

                resolve();
            };
        });

        return TextoImagemVideo.apiReadyPromise;
    }

    initComponent(component) {
        const videoElement = component.querySelector('[data-youtube-id]');
        const buttonVideoPlay = component.querySelector('[data-video-play]');

        if (!videoElement || !buttonVideoPlay) return;

        const videoId = videoElement.dataset.youtubeId;

        if (!videoId) return;

        const elementId = this.ensureElementId(videoElement, videoId);

        new YT.Player(elementId, {
            height: '360',
            width: '640',
            videoId,
            playerVars: {
                rel: 0,
                controls: 1,
                modestbranding: 1,
                disablekb: 0,
                fs: 1,
                playsinline: 1,
                origin: window.location.origin,
            },
            events: {
                onReady: (event) => {
                    TextoImagemVideo.players.set(elementId, event.target);
                },
                onStateChange: (event) => {
                    this.handleStateChange(event, component, elementId);
                },
                onError: (event) => {
                    console.warn('Erro no player YouTube:', event);
                },
            },
        });

        buttonVideoPlay.addEventListener('click', (event) => {

            event.preventDefault();

            event.stopPropagation();

            this.playVideo(elementId);

        });
    }

    ensureElementId(videoElement, videoId) {
        if (videoElement.id && videoElement.id.trim() !== '') {
            return videoElement.id;
        }

        videoElement.id = `yt-${videoId}`;
        return videoElement.id;
    }

    handleStateChange(event, component, elementId) {
        const playerElement = component.querySelector(`#${CSS.escape(elementId)}`);

        switch (event.data) {
            case YT.PlayerState.PLAYING:
                this.pauseOthers(elementId);

                component.classList.add('is-playing');

                if (playerElement) {
                    playerElement.classList.add('is-playing');
                }

                break;

            case YT.PlayerState.PAUSED:
            case YT.PlayerState.ENDED:
                component.classList.remove('is-playing');

                if (playerElement) {
                    playerElement.classList.remove('is-playing');
                }

                break;
        }
    }

    playVideo(elementId) {
        const player = TextoImagemVideo.players.get(elementId);

        if (!player || typeof player.playVideo !== 'function') return;

        try {
            player.playVideo();

            setTimeout(() => {
                const state = player.getPlayerState?.();

                if (state !== YT.PlayerState.PLAYING) {
                    if (typeof player.mute === 'function') {
                        player.mute();
                    }

                    player.playVideo();
                }
            }, 500);
        } catch (error) {
            console.warn('Erro ao tentar reproduzir o vídeo:', error);
        }
    }

    pauseOthers(currentElementId) {
        TextoImagemVideo.players.forEach((player, elementId) => {
            if (elementId === currentElementId) return;

            try {
                if (typeof player.pauseVideo === 'function') {
                    player.pauseVideo();
                }
            } catch (error) {
                console.warn('Erro ao pausar outro vídeo:', error);
            }
        });
    }
}

(() => {
    if (!MODULE.length) return;

    let initialized = false;

    const initLazy = () => {
        if (initialized) return;

        initialized = true;

        window.removeEventListener('scroll', initLazy);
        window.removeEventListener('click', initLazy);

        new TextoImagemVideo();
    };

    window.addEventListener('scroll', initLazy, {
        passive: true,
        once: true,
    });

    window.addEventListener('click', initLazy, {
        passive: true,
        once: true,
    });
})();

export default TextoImagemVideo;